import React, { createContext, useState, useContext } from 'react';

const ChatContext = createContext(null);

export const useChat = () => useContext(ChatContext);

export const ChatProvider = ({ children }) => {
    const [chatData, setChatData] = useState([]);
    const [totalUnreadCount, setTotalUnreadCount] = useState(0);
    const [refreshChat, setRefreshChat] = useState(false); // 기존 필드 유지

    return (
        <ChatContext.Provider value={{ chatData, setChatData, totalUnreadCount, setTotalUnreadCount, refreshChat, setRefreshChat }}>
            {children}
        </ChatContext.Provider>
    );
};